<template>
  <v-hover v-slot="{ hover }">
    <v-text-field v-model="boolText"
                  class="q-input"
                  :class="[BorderClass, CompactClass, BlurrClass, boolColor + '--inputtext', 'removeunderline']"
                  :background-color="BackgroundColor"
                  :label="labelText"
                  readonly
                  hide-details="auto"
                  :single-line="singleline"
                  :hoverbool="setHoverBool(hover)"
                  :color="boolColor"
                  flat>
      <!-- :rules="[required]" -->

      <!-- PREPEND SLOTS -->
      <template v-slot:prepend>
        <slot name="prepend-outer" />
      </template>

      <template v-slot:prepend-inner>
        <slot name="prepend" />
      </template>
      <!------------------->

      <!-- APPEND SLOTS -->
      <template v-slot:append>
        <v-switch :input-value="newValue"
                  :disabled="disabled"
                  :readonly="IsDisabled"
                  :color="trueColor"
                  dense
                  :ripple="!IsDisabled"
                  :rules="rules"
                  :loading="loading"
                  hide-details
                  @change="e => changeBool(e)"
                  class="q-switch pa-0 ma-0" />
        <ExternalChangeWarning v-if="externallychanged"
                               @Sync="(newValue = value, externallychanged = false)" />
      </template>

      <template v-slot:append-outer>
        <slot name="append-outer" />
      </template>
      <!------------------->

    </v-text-field>
  </v-hover>
</template>


<script>
import InputMixin from "@/helpers/Mixins/InputMixin";
import ExternalChangeWarning from "@/components/Inputs/Parts/ExternalChangeWarning.vue";

export default {
  name: "QSwitchInput",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    value: Boolean,
    singleline: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    emitOnlyOnBlur: Boolean,
    rules: Array,

    boolcolors: Object,
    booltexts: Object,
  },
  components: {
    ExternalChangeWarning,
  },
  mixins: [InputMixin],

  data() {
    return {
      edit: false,
      newValue: this.value,
    };
  },

  methods: {
    changeBool(val) {
      this.setEdit();
      this.newValue = val;
      this.blurInput();
    },
  },

  computed: {
    boolText() {
      return this.newValue ? this.trueText : this.falseText;
    },
    trueText() {
      return this.booltexts && this.booltexts.true
        ? this.booltexts.true
        : this.$t("servicesystem.common_objects.commonterms.yes");
    },
    falseText() {
      return this.booltexts && this.booltexts.false
        ? this.booltexts.false
        : this.$t("servicesystem.common_objects.commonterms.no");
    },

    boolColor() {
      return this.newValue ? this.trueColor : this.falseColor;
    },
    trueColor() {
      return this.boolcolors && this.boolcolors.true ? this.boolcolors.true : "primary";
    },
    falseColor() {
      return this.boolcolors && this.boolcolors.false ? this.boolcolors.false : "tertiary";
    },
  },

  watch: {},
};
</script>


<style >
.q-switch.v-input--is-disabled input {
  opacity: 0 !important;
}
</style>
